import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const kintone = defineConnector({
  identifier: "kintone",
  name: "Kintone",
  tagLine: "Business app platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://[^/]*\\.kintone\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Kintone instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Kintone instance.",
        },
        {
          kind: "input",
          label: "Subdomain",
          placeholder: "urdzw8p24agp",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
          helperText: "The subdomain for your Kintone account",
        },
      ],
    },
    {
      title: "Create a Kintone app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Kintone authentication docs](https://kintone.dev/en/docs/common/authentication/) and register an OAuth client in your Kintone environment. Copy the client ID and client secret, and note your Kintone subdomain.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/kintone/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Kintone account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Kintone account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://${configuration.subdomain}.kintone.com/oauth2/authorization`,
    tokenEndpoint: (configuration) =>
      `https://${configuration.subdomain}.kintone.com/oauth2/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.subdomain}.kintone.com/`,
  },
  publicEnvVars: ({ subdomain }) => ({
    KINTONE_URL: subdomain ? `https://${subdomain}.kintone.com` : "",
  }),
});
